<template>
  <rid-field
    v-if="hasItems(authors)"
    label="Авторы"
    icon="mdi-account-hard-hat"
    :value="authors.join(', ')"
  />
  <rid-field
    v-if="hasItems(holders)"
    label="Правообладатели"
    icon="mdi-account-tie"
    :value="holders.join(', ')"
  />
</template>

<script setup>
import RidField from '@/components/Rid/RidField.vue'

defineProps({
  authors: {
    type: Array,
    required: true,
  },
  holders: {
    type: Array,
    required: true,
  },
})

const hasItems = (arr) => Array.isArray(arr) && arr.length > 0
</script>

<style scoped lang="scss">

</style>
